module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table-row/table-row.component.html
// module id = ../../../../../src/app/shared/components/table/table-row/table-row.component.html
// module chunks = 12